var $38854e2b175151fa$exports = {};
$38854e2b175151fa$exports = {
  "Empty": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{437}\u{43D}\u{438}`
};
export { $38854e2b175151fa$exports as default };